import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OauthService } from '../services/oauth.service';
import { RepoService } from '../services/repo.service';
import { ToastService } from '../services/toast.service';

/**
 * Gate /sdtm behind the sas2r session. Unlike workspaceAccessGuard this does not
 * require a selected repo — the CRF Annotation Hub only needs an authenticated user.
 */
export const sdtmAccessGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const auth = inject(OauthService);
  const repoService = inject(RepoService);
  const toastService = inject(ToastService);

  const user = await auth.getUser();
  
  if (!user) {
    router.navigate(['/']);
    return false;
  }

  if (!repoService.repo()) {
    console.log('Access to workspace denied: No repository selected');
    toastService.showError('Please connect the repository to access SDTM');
    router.navigate(['/']);
    return false;
  }
  return true;
};
